/* eslint-disable @typescript-eslint/no-empty-function */
import React from "react";
import Slider from "react-slick";

// Components //
import CardAlert from "../../atoms/card-alert/CardAlert";
import TitleSection from "../../molecules/title-section";
import MediaCard from "../..//molecules/media-card/mediaCard";
import Button from "../../atoms/button/button";

// Utils //
import rawToReact from "../../../utils/rawToReact";
import contentfulRenderOptions from "../../../utils/contentfulRenderOption";
import { useCeidRecomendation } from "./query";

// Styles //
import "slick-carousel/slick/slick.css";
import "./ResultFormPreCEID.scss";

const MAIN_CLASSNAME = "o-result-form-pre-ceid";

interface ResultFormPreCEIDProps {
    alertContent: any;
}

const ResultFormPreCEID = ({ alertContent }: ResultFormPreCEIDProps) => {
    const { digitalSkill } = useCeidRecomendation();

    const isBrowser = typeof window !== "undefined";

    const urlOrigin = isBrowser ? window.location.origin : "";

    const CarouselGeneral = {
        arrows: false,
        slidesToScroll: 1,
        waitForAnimate: false,
        autoplay: false,
        fade: false,
        autoplaySpeed: 10000,
        variableWidth: true,
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    variableWidth: false,
                },
            },
            {
                breakpoint: 570,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: true,
                },
            },
        ],
    };

    return (
        <div className={`${MAIN_CLASSNAME}`}>
            <div className="m-pre-aceleradora-succes-container">
                <CardAlert
                    title={
                        alertContent?.tituloPrincipal || "Información enviada"
                    }
                    btnText={alertContent?.tituloBoton}
                    href={alertContent?.redireccionBoton}
                >
                    <p>
                        {rawToReact(
                            alertContent.descripcion.raw,
                            contentfulRenderOptions
                        )}
                    </p>
                </CardAlert>
            </div>
            {/* recomendaciones */}
            <section className={`${MAIN_CLASSNAME}__recomendaciones`}>
                <TitleSection
                    title="Aprovecha nuestro contenido gratis y potencia tus competencias digitales"
                    type="h4"
                />

                <div className={`${MAIN_CLASSNAME}__recomendaciones__slider`}>
                    <Slider {...CarouselGeneral}>
                        {digitalSkill?.map((post, postIdx) => {
                            const { postData: item } = post as any;
                            return (
                                <div key={`post-${post.slug}-${postIdx}`}>
                                    <MediaCard
                                        tituloMultimedia={item.tituloMultimedia}
                                        descripcion={item.descripcion}
                                        imagenPrincipal={item.imagenPrincipal}
                                        tituloBoton={"Ver más"}
                                        tematica={item.tematica}
                                        categoriaMultimedia={
                                            item.categoriaMultimedia
                                        }
                                        nuevoContenido={false}
                                        textoIntroductorio={
                                            item.textoIntroductorio
                                        }
                                        slug={`${urlOrigin}/servicio-de-empleo/personas/biblioteca/${item.parentSlug}${item.slug}`}
                                        parentContentfulId={
                                            item.parentContentfulId
                                        }
                                        createdAt={item.createdAt}
                                        tituloEvento={""}
                                        tipoEvento={""}
                                        modoEvento={""}
                                        fechaEvento={""}
                                        horaEvento={""}
                                        lugarEvento={""}
                                        disclaimer={""}
                                        onClickShare={() => {}}
                                        setLinkUrl={() => {}}
                                    />
                                </div>
                            );
                        })}
                    </Slider>
                </div>
            </section>

            <div className={`${MAIN_CLASSNAME}__library`}>
                <TitleSection
                    title="Encuentra másterclass, podcast y artículos con contenido que puede interesarte"
                    type="h5"
                />

                <Button
                    self
                    type={"link"}
                    href={
                        "https://www.comfama.com/servicio-de-empleo/personas/biblioteca/"
                    }
                    classname={`a-button__magenta_aceleradora big center`}
                    text={"Ir a biliotecas"}
                    isDisabled={false}
                />
            </div>
        </div>
    );
};

export default ResultFormPreCEID;
